import { ComponentProps, useMemo } from "react";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { router } from "src/js/router/react-router";
import ROUTES from "src/js/router/routes";

import { Navbar } from "react-migration/domains/nav/components/Navbar";
import { updateSelection } from "src/js/stores/map/actions/updateSelection";
import { updateExpandedLHS } from "src/js/stores/map/actions/updateExpandedLHS";
import { updateShowWorkbench } from "src/js/stores/map/actions/updateShowWorkbench";

export const NavbarMobile = ({
  activeRoute = "",
}: ComponentProps<"div" & { activeRoute: string | null; publicApp: boolean }>) => {
  const { t } = useTranslation();

  const mapActive = useMemo(() => {
    if (!activeRoute) return false;
    return activeRoute.includes("map") || activeRoute.includes("search") || activeRoute.includes("legacy-search");
  }, [activeRoute]);

  return (
    <Navbar.Wrapper data-testid="navbar-mobile">
      <Navbar.Item
        data-testid="navbar-map-mobile"
        active={!/\/(dashboard|sites)/.test(window.location.pathname) || !window.location.pathname}
        leadIcon="lt-map-2-line"
        onClick={() => {
          if (!mapActive) router.push({ name: ROUTES.MAP });
          updateSelection(undefined);
          updateExpandedLHS(false);
          updateShowWorkbench(false);
        }}
        mobile={true}
      >
        {t("nav.nav.map")}
      </Navbar.Item>
      <Navbar.Item
        data-testid="navbar-sites-mobile"
        active={window.location.pathname.includes("/sites")}
        leadIcon="lt-kanban-line"
        onClick={() => router.push({ name: ROUTES.SITES })}
        mobile={true}
      >
        {t("nav.nav.sites")}
      </Navbar.Item>
      <Navbar.Item
        data-testid="navbar-dashboard-mobile"
        active={window.location.pathname.includes("/dashboard")}
        leadIcon="lt-user-3-line"
        onClick={() => {
          router.push({ name: ROUTES.DASHBOARD });
        }}
        mobile={true}
      >
        {t("nav.nav.dashboard")}
      </Navbar.Item>
    </Navbar.Wrapper>
  );
};
